import { httpClient } from '@/services/http/httpClient'

export type LinkIdeaParams = {
  ideaId: string
  ideaIdToLink: string
}

export async function linkIdea({ ideaId, ideaIdToLink }: LinkIdeaParams) {
  await httpClient.post('ideas/idea-links/link', {
    primaryIdeaId: ideaId,
    secondaryIdeaId: ideaIdToLink,
  })
}
